import { Link } from '@inertiajs/react'

type ConnectionsPage = 'integrations' | 'credentials'

interface Props {
  current: ConnectionsPage
}

const pages: Array<{ key: ConnectionsPage; label: string; href: string }> = [
  { key: 'integrations', label: 'Integrações', href: '/dashboard/integrations' },
  { key: 'credentials', label: 'Credenciais', href: '/dashboard/credentials' },
]

// Organization-level counterpart to WorkerPortalNav's Conexões sisters.
// These remain real routes so bookmarks and browser history keep working.
export default function OrganizationConnectionsNav({ current }: Props) {
  return (
    <nav
      data-testid="organization-connections-nav"
      aria-label="Seções de conexões da organização"
      className="flex max-w-full gap-1 overflow-x-auto overflow-y-hidden [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
    >
      {pages.map((page) => {
        const active = page.key === current

        return (
          <Link
            key={page.key}
            href={page.href}
            aria-current={active ? 'page' : undefined}
            className={`whitespace-nowrap rounded-full px-2.5 py-1 text-[13px] font-medium transition-colors duration-150 ${
              active
                ? 'bg-accent text-foreground'
                : 'text-muted-foreground hover:bg-accent hover:text-foreground'
            }`}
          >
            {page.label}
          </Link>
        )
      })}
    </nav>
  )
}
